export default class AbstractMonitor {
  constructor($locator) {
    this.$locator = $locator
    this.$bus = $locator.$bus

    // By default there is no dictionary of i18n. Some errors are detected
    // before we are able to parse the i18n objects and no language has
    // been detected.
    this.$store = $locator.$store
  }

  getTranslation(keyword) {
    return this.$store.getters.translate(keyword)
  }
}
